/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance, AxiosResponse } from "axios";

export type ServiceKind =
  | "internet"
  | "cloud"
  | "datacenter"
  | "port"
  | "extender-pop"
  | "extender-pop-cpe";

// type CommonData = { name?: string; tag?: string };
type CommonData = { name?: string; tag?: string | string[] };

// Discriminated union enforces tenantId where needed
export type UpdateMetaParams =
  | {
      kind: "internet" | "cloud" | "datacenter" | "extender-pop";
      resourceId: string;        // connectionId, datacenterId or Extender PoP id
      tenantId: number;
      data: CommonData;
    }
  | {
      kind: "port";
      resourceId: string;
      tenantId: number;      // portId
      data: CommonData;          // no tenantId for port
    }
  | {
      kind: "extender-pop-cpe";
      resourceId: string;        // CPE id
      parentId?: string;         // its Extended PoP (site) id; required
      tenantId: number;
      data: CommonData;
    };

export function updateConnectionMeta(
  api: AxiosInstance,
  params: UpdateMetaParams
): Promise<AxiosResponse> {
  const { kind, resourceId, data } = params;

  switch (kind) {
    case "internet": {
      // PATCH /kontroledge/internet/:id?tenantId=...
      return api.patch(
        `/kontroledge/internet/${resourceId}?tenantId=${params.tenantId}`,
        data
      );
    }
    case "cloud": {
      // PATCH /kontroledge/cloud-connectivity/:id?tenantId=...
      return api.patch(
        `/kontroledge/cloud-connectivity/${resourceId}?tenantId=${params.tenantId}`,
        data
      );
    }
    case "datacenter": {
      // PUT /kontroledge/datacenter-interconnect/:id?tenantId=...
      return api.put(
        `/kontroledge/datacenter-interconnect/${resourceId}?tenantId=${params.tenantId}`,
        data
      );
    }
    case "port": {
      // PATCH /kontroledge/ports/:id   (no tenantId)
      return api.patch(`/kontroledge/ports/${resourceId}?tenantId=${params.tenantId}`, data);
    }
    case "extender-pop": {
      // PATCH /kontroledge/extender-pops/:id?tenantId=...
      // Name only: its tags live in the Tags API, and the endpoint rejects
      // any other field.
      return api.patch(
        `/kontroledge/extender-pops/${resourceId}?tenantId=${params.tenantId}`,
        { name: data.name }
      );
    }
    case "extender-pop-cpe": {
      // PATCH /kontroledge/extender-pops/:id/cpes/:cpeId?tenantId=...
      // Name only, like its site (CTX-832); the URL needs the site too.
      if (!params.parentId) {
        return Promise.reject(
          new Error("extender-pop-cpe needs the Extended PoP id (parentId)")
        );
      }
      return api.patch(
        `/kontroledge/extender-pops/${params.parentId}/cpes/${resourceId}?tenantId=${params.tenantId}`,
        { name: data.name }
      );
    }
    default: {
      // Exhaustive check
      const _never: never = kind;
      return Promise.reject(new Error(`Unsupported kind: ${_never as any}`));
    }
  }
}

